// Converting string's first letter to lower case if the string contains a _
export const firstToLowerCase = (s) => {
  let result = s.includes("_") ? s : s.charAt(0).toLowerCase() + s.slice(1);
  return result;
};

// Converting string from Snake Case to Camel Case
export const toCamel = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace("-", "").replace("_", "");
  });
};

// Remove special characters
export const noSpecialCharacters = (s) => {
  return s
    .replace(/[^\w -]/g, "")
    .replace(" - ", "-")
    .trim();
};
